import { SimpleGrid, Flex, Text, Image, Highlight } from "@chakra-ui/react";
import React, { memo } from "react";
import { getAlohainfoWhatData } from "@/constants/alohainfo-contants";
export default memo(function WhatComponent() {
   var list = getAlohainfoWhatData();
   return (
      <>
         <Text
            maxW={{ base: "90%", BREAK_PAD: "80%", BREAK_LPC: "70%" }}
            mx={"auto"}
            mt={{ base: "60px", BREAK_PAD:'90px',BREAK_LPC: "120px" }}
            fontSize={{ base: 24, BREAK_LPC: 34 }}
            fontFamily={{ base: "Arial-BoldMT", BREAK_LPC: "Arial" }}
            textAlign="center">
            <Highlight query="What" styles={{ color: "green.500" }}>
               What are the key features of AlohaBots?
            </Highlight>
         </Text>
         <SimpleGrid
            w={{ base: "90%", BREAK_PAD: "740px", BREAK_LPC: "960px", BREAK_PC: "1280px" }}
            columns={{ base: 1, BREAK_PAD: 2, BREAK_LPC: 3 }}
            gridGap={{ base: "30px", BREAK_LPC: "60px" }}
            mx={"auto"}
            mt={{ base: "30px",BREAK_PAD:'65px', BREAK_LPC: "100px" }}
            mb={{ base: "50px", BREAK_PAD:'80px', BREAK_LPC: "110px" }}>
            {list.map((item) => {
               return (
                  <Flex
                     flexDir={{ base: "row", BREAK_LPC: "column" }}
                     key={item.title}>
                     <Image
                        alt={item.title}
                        userSelect="none"
                        className="refImg"
                        src={undefined}
                        data-src={process.env.REACT_APP_PUBLIC_URL + item.icon}
                        boxSize={{ base: "20px",BREAK_PAD:'24px', BREAK_LPC: "36px" }}
                        mb={"24px"}
                     />
                     <Flex flexDir={"column"} flex={'1'} ml={{ base: "10px", BREAK_LPC: "0px" }}>
                        <Text
                           fontSize={{ base: 18, BREAK_LPC: 20 }}
                           lineHeight={1}>
                           {item.title}
                        </Text>
                        <Text
                           pr={'24px'}
                           fontSize={16}
                           lineHeight={{BREAK_LPC: "22px" }}
                           color={"#333"}
                           mt={{ base: "12px", BREAK_LPC: "16px" }}>
                           {item.info}
                        </Text>
                     </Flex>
                  </Flex>
               );
            })}
         </SimpleGrid>
      </>
   );
});
